import Product from '@/models/product';
import { ProductProps } from '@/interfaces/models/product';

type categoriesResponse = {
  categories: any[];
  defaultCategory: {
    products: ProductProps[]
  };
};

const transformCategory = (category: any) => {
  category.products = category.products.map(Product.createFromRequest);

  return category;
};

export default () => {
  if (Array.isArray(window.axios.defaults.transformResponse)) {
    return window.axios.defaults.transformResponse.concat((categoriesResponse: categoriesResponse): any => {
      const categories = categoriesResponse.categories.map(transformCategory);
      const defaultCategory = transformCategory(categoriesResponse.defaultCategory);

      return {
        categories,
        defaultCategory
      };
    });
  }
};
